import * as Cesium from "cesium";
import "../../public/Widgets/widgets.css";

export async function initViewer(options = {}) {
  // 配置静态资源路径
  const {
    cesiumBaseUrl = "https://cdn.cesium.com/cesiumjs/1.131/Build/Cesium/",
    useLocalAssets = false,
    ionAccessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4NTg1NWQzNC05N2YyLTQ1MmQtOTZhOC1mNjJkZjg1OTljNDMiLCJpZCI6MzExNzc4LCJpYXQiOjE3NDk3ODAyNzd9.3zLZ8Dv48IzyXseYPE-gAO0omEKttnDOwc526sHRopU"
  } = options;

  // 设置基础路径
  if (useLocalAssets) {
    // 使用本地资源
    window.CESIUM_BASE_URL = "/node_modules/@v2x-three/cesium/dist/";
  } else {
    // 使用CDN资源
    window.CESIUM_BASE_URL = cesiumBaseUrl;
  }

  // 设置 Cesium Ion token
  Cesium.Ion.defaultAccessToken = ionAccessToken;

  // 设置 cesium 默认视角
  Cesium.Camera.DEFAULT_VIEW_RECTANGLE = new Cesium.Rectangle.fromDegrees(
    // 西边经度
    89.5,
    // 南边纬度
    20.4,
    // 东边经度
    110.4,
    // 北边纬度
    61.2
  );

  const viewer = new Cesium.Viewer("cesiumContainer", {
    infoBox: false,
    // 是否显示搜索框
    geocoder: false,
    // 是否显示 home 按钮
    homeButton: false,
    // 是否显示场景模式选择器
    sceneModePicker: false,
    // 是否显示导航帮助按钮
    navigationHelpButton: false,
    // 是否显示动画按钮
    animation: false,
    // 是否显示时间轴
    timeline: false,
    // 是否显示全屏按钮
    fullscreenButton: true,
    // 是否显示图层选择器
    baseLayerPicker: false, // 关闭图层选择器避免切换到有问题的地图
  });

  //   设置沙箱允许使用;
  var iframe = document.getElementsByClassName("cesium-infoBox-iframe")[0];
  if (iframe) {
    iframe.setAttribute(
      "sandbox",
      "allow-same-origin allow-scripts allow-popups allow-forms"
    );
    iframe.setAttribute("src", "");
  }

  // 隐藏 logo
  viewer.cesiumWidget.creditContainer.style.display = "none";

  // 添加3D 建筑 - 修复异步调用
  try {
    const osmBuildings = await Cesium.createOsmBuildingsAsync();
    viewer.scene.primitives.add(osmBuildings);
  } catch (error) {
    console.error("加载 OSM 建筑失败:", error);
  }

  // 初始化完成，相机位置将在 App.vue 中设置

  return viewer;
}
